module.exports = __webpack_public_path__ + "static/media/looccitane.c27b1969.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/brand/cards-benefits/cards-new/looccitane.png
// module id = 2218
// module chunks = 37